<template>
<div class="container p-0">
  <header class="theme-color row p-2">
    <div class="col-sm-4 p-2">
      <RouterLink class="float-left" :to="`${publicPath}`">
        <img class="p-2" :src="`${publicPath}favicon.svg`" />
        <span class="title" style="color: black;">sipr Project</span>
      </RouterLink>
    </div>
    <div class="col-8 p-2">
      <nav class="float-right">
        <RouterLink class="float-left p-2" :to="`${publicPath}`">Home</RouterLink>
        <RouterLink class="float-left p-2" :to="`${publicPath}passage/Genesis 1:1`">Application</RouterLink>
        <RouterLink class="float-left p-2" :to="`${publicPath}theory`">Theory</RouterLink>
        <RouterLink class="float-left p-2" :to="`${publicPath}about`">About</RouterLink>
      </nav>
    </div>
  </header>
  <main class="theme-color row p-2">
    <RouterView />
  </main>
  <footer class="i-theme-color row p-2">
    <div class="p-2 text-center">
      A Digital Humanities project developed by Fernando Jimenez SJ <br />
      <a href="mailto:frjimene@bc.edu">frjimene@bc.edu</a><br />
      2026
    </div>
  </footer>
</div>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {
      publicPath: process.env.BASE_URL,
    }
  },
  components: {
  },
  methods: {
  },
}
</script>

<style></style>
